import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import React from "react";
import { connect} from "react-redux";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";

const mapStateToProps = (state: ApplicationState) => {
    return {
        session: state.context.session,
        signInPageUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    };
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & HasHistory;

const InvoiceRequestRmaPage = ({
    session,
    id,
    signInPageUrl,
    history
}: Props) => {

    if(!session.isAuthenticated && signInPageUrl)
    {
         history.push(signInPageUrl);
    }
    return (
        <Page>
             <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps)(withHistory(InvoiceRequestRmaPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "RequestRmaPage" instead of this constant.
 */
//export const RequestRmaPageContext = "InvoiceRequestRmaPage";
